import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faMousePointer,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";

const AdvertisementPage = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="flex items-center gap-4 mb-8">
        <span className="text-4xl">📢</span>
        <h1 className="text-3xl font-bold">Advertisement Banners</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <img
            src="https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
            alt="Advertisement banners"
            className="rounded-lg shadow-md w-full h-64 object-cover"
          />

          <div className="mt-6 bg-white p-6 rounded-lg shadow-sm border border-gray-100">
            <h2 className="text-xl font-semibold mb-4">Premium Ad Placement</h2>
            <div className="space-y-4">
              <div className="flex justify-between">
                <span className="font-medium">Placement Duration</span>
                <span>30 days</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Impressions</span>
                <span>10,000+</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">CTR Guarantee</span>
                <span>2% minimum</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Price</span>
                <span className="font-bold">20,000 MMK/month</span>
              </div>
            </div>

            <button className="mt-6 w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition">
              Book Ad Space
            </button>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-4">Why Our Ads Work</h2>
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <FontAwesomeIcon icon={faEye} className="text-blue-500 mt-1" />
              <div>
                <h3 className="font-medium">High Visibility Locations</h3>
                <p className="text-gray-600">
                  Prime placement on our platform's busiest pages
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <FontAwesomeIcon
                icon={faMousePointer}
                className="text-green-500 mt-1"
              />
              <div>
                <h3 className="font-medium">Interactive Designs</h3>
                <p className="text-gray-600">
                  Clickable banners that drive customer engagement
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <FontAwesomeIcon
                icon={faChartBar}
                className="text-orange-500 mt-1"
              />
              <div>
                <h3 className="font-medium">Performance Analytics</h3>
                <p className="text-gray-600">
                  Detailed reports on views, clicks, and conversions
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8">
            <h3 className="text-xl font-semibold mb-4">Ad Format Examples</h3>
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
                alt="Horizontal banner"
                className="rounded-lg h-32 object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
                alt="Square banner"
                className="rounded-lg h-32 object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
                alt="Vertical banner"
                className="rounded-lg h-32 object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
                alt="Popup banner"
                className="rounded-lg h-32 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertisementPage;
